module.exports = __webpack_public_path__ + "../resources/img/ic_arrow_right.8a5940b7.svg";